export const API_PATH_ApiTrafficStudyGet = '/services/traffic-studies/apiTrafficStudyGet';
